<template>
  <div class="columns">
    <div class="column is-4">
      <strong>{{ title1 }}</strong>
      <textarea :value="ta1" @keyup="$emit('update:ta1', $event.target.value)" placeholder="type here"></textarea>
    </div>
    <div class="column is-4">
      <strong>{{ title2 }}</strong>
      <textarea :value="ta2" @keyup="$emit('update:ta2', $event.target.value)" placeholder="type here"></textarea>
    </div>
    <div class="column is-4">
      <strong>{{ title3 }}</strong>
      <textarea :value="ta3" @keyup="$emit('update:ta3', $event.target.value)" placeholder="type here"></textarea>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'multi-answer',
    components: {
    },
    data () {
      return {
        isOpen: false,
        autoHeightInterval: null,
        showCardContent: false,
        uniqueId: null
      }
    },
    props: {
      title1: {
        type: String,
        required: false,
        default: 'I see...'
      },
      title2: {
        type: String,
        required: false,
        default: 'I notice...'
      },
      title3: {
        type: String,
        required: false,
        default: 'I wonder...'
      },
      ta1: {
        type: String,
      },
      ta2: {
        type: String,
      },
      ta3: {
        type: String,
      }
    },
  }
</script>

<style lang="scss" scoped>
textarea {
  width: 100%;
  min-height: 180px;
  font-size: 1rem;
  padding: 4px 6px 4px 6px;

  margin-top: 1rem;
  border: 2px solid #363636;
  box-shadow: 4px -4px #23c6c8;

}
</style>



// WEBPACK FOOTER //
// MultiAnswer.vue?aeb3db54